import { PartnerBar } from '@/components/organisms/PartnerBar/PartnerBar';
import { PartnerContact } from '@/components/organisms/PartnerContact/PartnerContact';
import { PartnerEVSavings } from '@/components/organisms/PartnerEVSavings/PartnerEVSavings';
import { PartnerEVStore } from '@/components/organisms/PartnerEVStore/PartnerEVStore';
import { PartnerHero } from '@/components/organisms/PartnerHero/PartnerHero';
import { PartnerInformation } from '@/components/organisms/PartnerInformation/PartnerInformation';
import { PartnerInventoryListing } from '@/components/organisms/PartnerInventoryListing/PartnerInventoryListing';
import { PartnerReviews } from '@/components/organisms/PartnerReviews/PartnerReviews';
import { FC, useRef } from 'react';

export const PartnerTemplate: FC = () => {
  const navBarRef = useRef<HTMLDivElement>(null);
  const inventoryRef = useRef<HTMLDivElement>(null);
  const evStoreRef = useRef<HTMLDivElement>(null);
  const evSavingsRef = useRef<HTMLDivElement>(null);
  const reviewsRef = useRef<HTMLDivElement>(null);
  const faqRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);

  return (
    <section className="relative">
      <section
        className={'sticky top-0 z-20 hidden w-full justify-center ml:flex'}
        ref={navBarRef}
      >
        <PartnerBar
          wrapperRef={navBarRef}
          navButtons={[
            { ref: inventoryRef, label: 'Inventory' },
            { ref: evStoreRef, label: 'EV Store' },
            { ref: evSavingsRef, label: 'EV Savings Badge' },
            { ref: reviewsRef, label: 'Testimonials' },
            { ref: faqRef, label: 'FAQ' },
          ]}
          actionButton={{ ref: contactRef, label: 'Become a partner' }}
        />
      </section>
      <section>
        <PartnerHero />
      </section>
      <section ref={inventoryRef}>
        <PartnerInventoryListing />
      </section>
      <section ref={evStoreRef}>
        <PartnerEVStore />
      </section>
      <section ref={evSavingsRef}>
        <PartnerEVSavings />
      </section>
      <section ref={reviewsRef}>
        <PartnerReviews />
      </section>
      <section ref={faqRef}>
        <PartnerInformation />
      </section>
      <section ref={contactRef}>
        <PartnerContact />
      </section>
    </section>
  );
};
